import isMobile from 'is-mobile';
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import styled, { css } from 'styled-components';

import { detectBrowser } from '../../utilities';

const Scrollbar = forwardRef(function Scrollbar(
  { children, trackColor, trackWidth: width, thumbColor, thumbHoverColor, ...otherProps },
  ref
) {
  return (
    <StyledScrollbars
      renderTrackHorizontal={props => (
        <Track {...props} className="track-horizontal" style={{ display: 'none' }} />
      )}
      renderThumbHorizontal={props => (
        <Thumb {...props} className="thumb-horizontal" style={{ display: 'none' }} />
      )}
      renderTrackVertical={({ style, ...props }) => (
        <Track {...props} style={{ ...style, width }} trackBackgroundColor={trackColor} />
      )}
      renderThumbVertical={props => (
        <Thumb {...props} backgroundColor={thumbColor} backgroundColorHover={thumbHoverColor} />
      )}
      ref={ref}
      {...otherProps}
    >
      {children}
    </StyledScrollbars>
  );
});

Scrollbar.displayName = 'Scrollbar';

Scrollbar.propTypes = {
  children: PropTypes.node,
  trackColor: PropTypes.string,
  trackWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  thumbColor: PropTypes.string,
  thumbHoverColor: PropTypes.string
};

const StyledScrollbars = styled(Scrollbars)`
  ${() =>
    (isMobile() || detectBrowser.isSafari) &&
    css`
      position: static !important;
    `}
`;

const Track = styled.span`
  top: 0;
  right: 2.5px;
  height: 100%;
  background-color: ${({ trackBackgroundColor }) => trackBackgroundColor};
`;

const Thumb = styled.span`
  background-color: ${({ backgroundColor }) => backgroundColor};

  &:hover {
    background-color: ${({ backgroundColorHover }) => backgroundColorHover};
  }
`;

export default Scrollbar;
